import {
  AppBar,
  Box,
  Divider,
  Grid,
  IconButton,
  Slide,
  Toolbar,
  useScrollTrigger,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "../../styles/svg/mobile_menu.svg";

import NavigationBoards from "./components/Boards";
import "./dashboard.scss";
import { localStorageInstance } from "../../utils/localStorage";
import { useLoginUser } from "../../utils/reactQuery/users";
import { user } from "../../redux/usersSlice";
import Profile from "../../components/Header/Profile";
import { useResponsive } from "../../hooks/useResponsive";
import { setSideBarDrawer } from "../../redux/Sidebar";
import { useAssets } from "../../utils/reactQuery/domainAssets";
import {
  getAPIBaseUrl,
  currentUserId,
  currentUserToken,
} from "../../utils/constants";
import TenantSiteName from "../../components/TenantSiteName";
import { useBoards } from "../../utils/reactQuery/boards";
import { setActiveBoards } from "../../redux/ActiveBoardSlice";
import SearchBoard from "../../components/Header/SearchBoard";
import WorklogMissing from "../../components/WorklogMissing";
import RemoveRemindTime from "../../components/WorklogMissing/RemoveRemindTime";
import DrawerGlobalComp from "../../components/Drawer";
import ChatSupport from "../../components/ChatSupport";

export default function Dashboard() {
  const userId = currentUserId();
  const [isWorklogRemindExipred, setisWorklogRemindExipred] = useState(
    localStorageInstance.getItem("worklog-remind")
  );
  const { data } = useLoginUser(userId);
  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const sideBarDrawer = useSelector(
    (state) => state.sideBarDrawer.sideBarDrawer
  );
  const { isLoading, boards, isError } = useBoards();

  useEffect(() => {
    setisWorklogRemindExipred(localStorageInstance.getItem("worklog-remind"));
  }, [localStorageInstance.getItem("worklog-remind")]);

  useEffect(() => {
    if (boards) {
      dispatch(
        setActiveBoards(
          boards?.data?.data?.responseData
            .filter((el) => !el.is_archive)
            .sort(function (a, b) {
              return a.board_name.localeCompare(b.board_name);
            }) || []
        )
      );
    }
  }, [isLoading, , isError]);

  const { logo, daily_worklog_reminder } = useAssets();
  const apiUrl = getAPIBaseUrl();
  if (data) {
    dispatch(user(data.data.data.responseData));
  }

  function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
    });

    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children ?? <div />}
      </Slide>
    );
  }
  return (
    <Box>
        <ChatSupport />
      <RemoveRemindTime />
      {!isWorklogRemindExipred && daily_worklog_reminder && <WorklogMissing />}
      {isMobile ? (
        <div>
          <HideOnScroll>
            <AppBar className={`appbar ${isMobile ? "mobile-appbar" : ""}`}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  className="app-menu-button"
                  onClick={() => dispatch(setSideBarDrawer(true))}
                >
                  <img src={MenuIcon} alt="menu" className="app-menu-icon" />
                </IconButton>

                {logo ? (
                  <img
                    src={`${apiUrl}/${logo}`}
                    alt="logo"
                    width={140}
                    className="appbar-logo"
                  />
                ) : (
                  <TenantSiteName />
                )}
                <div className="justify-content-end w-100">
                  <Profile />
                </div>
              </Toolbar>
            </AppBar>
          </HideOnScroll>
          {/* <Toolbar /> */}
          <Outlet />
        </div>
      ) : (
        <Box className="wrapper_dashboard">
          <Box className="wrapper_sidebar">
            <div className="logo-container">
              {logo ? (
                <img
                  src={`${apiUrl}/${logo}`}
                  className="board-logo"
                  alt="Sofmen"
                />
              ) : (
                <TenantSiteName />
              )}
            </div>
            <Divider />
            <NavigationBoards
              boards={boards?.data?.data?.responseData}
              isLoading={isLoading}
              isError={isError}
            />
          </Box>
          <Box className="wrapper_main_container">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <div style={{ height: "47px" }}></div>
                <div className="top-bar">
                  <Profile />
                </div>
                <div className="main-container">
                  <Outlet />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      <DrawerGlobalComp
        open={sideBarDrawer}
        setOpen={(value) => dispatch(setSideBarDrawer(value))}
        anchor={"left"}
        animatedWidth={260}
      >
        <Box className="wrapper_dashboard">
          <Box className="wrapper_sidebar">
            <div className="logo-container">
              <img
                src={`${apiUrl}/${logo}`}
                className="board-logo"
                alt="Sofmen"
              />
            </div>
            {/* <Profile /> */}
            <Divider />
            <NavigationBoards
              boards={boards?.data?.data?.responseData}
              isLoading={isLoading}
              isError={isError}
            />
          </Box>
        </Box>
      </DrawerGlobalComp>
    </Box>
  );
}
